import { Check, Crown, ShieldCheck } from "lucide-react";

const INCLUDES = ["All 8 report categories", "Full evidence & screenshots", "Individual report tabs", "Exportable reports (PDF · JSON · MD)", "Private access link"];

const Plan = ({ id, name, price, sub, cta, best, onBuy }) => (
  <div data-testid={`plan-${id}`} className={`rea-panel relative flex flex-col p-6 transition-transform duration-300 hover:-translate-y-1 sm:p-7 ${best ? "rea-gold-glow border-[#d4af37]/50" : "rea-brackets"}`}>
    {best && (
      <span data-testid="plan-best-value-badge" className="absolute -top-3 left-6 flex items-center gap-1.5 bg-[#d4af37] px-2.5 py-1 font-mono text-[10px] font-bold uppercase tracking-widest text-black">
        <Crown className="h-3 w-3" /> Best value
      </span>
    )}
    <p className="rea-label">{name}</p>
    <p className="mt-3 font-display text-4xl font-bold">${price}<span className="ml-2 font-mono text-sm font-normal text-neutral-400">USDC</span></p>
    <p className={`mt-1 text-sm ${best ? "text-[#d4af37]" : "text-neutral-400"}`}>{sub}</p>
    <ul className="mt-5 flex-1 space-y-2">
      {INCLUDES.map((x) => <li key={x} className="flex items-start gap-2 text-sm text-neutral-300"><Check className="mt-0.5 h-4 w-4 flex-none text-red-500" />{x}</li>)}
    </ul>
    <button data-testid={`buy-${id}-btn`} onClick={onBuy}
      className={`mt-6 w-full py-3.5 font-mono text-xs font-bold uppercase tracking-[0.2em] transition-colors ${best ? "bg-[#d4af37] text-black hover:bg-[#e6c459]" : "bg-red-700 text-white hover:bg-red-600"}`}>
      {cta}
    </button>
  </div>
);

export const Paywall = ({ onSelect }) => (
  <section data-testid="paywall" className="anim-rise">
    <p className="rea-label text-red-500">// access restricted</p>
    <h1 className="font-hero mt-3 text-3xl uppercase leading-[1.05] sm:text-4xl lg:text-5xl">
      Unlock <span className="text-red-600">R.E.A.</span><br />Intelligence
    </h1>
    <p className="mt-5 max-w-xl text-base text-neutral-400 md:text-lg">
      Get a complete technical, visual, and functional investigation of your target website, organized into detailed reports you can browse, revisit, and export.
    </p>
    <div className="mt-10 grid gap-6 md:grid-cols-2">
      <Plan id="single" name="Single Investigation" price="6.99" sub="One investigation" cta="Buy 1 Report" onBuy={() => onSelect("single")} />
      <Plan id="bundle" name="Intelligence Bundle" price="39.99" sub="Ten investigations · approximately $4 per investigation" cta="Buy 10 Reports" best onBuy={() => onSelect("bundle")} />
    </div>
    <p data-testid="paywall-terms" className="mt-6 flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-neutral-400">
      <ShieldCheck className="h-4 w-4 text-[#d4af37]" /> No subscriptions. No recurring charges. No credit cards.
    </p>
    <p className="mt-2 text-xs text-neutral-500">Paid in USDC on Base or Solana. Credits unlock only after on-chain verification.</p>
  </section>
);
